import type { ReactNode } from "react";

/** Titre d'écran, le même partout : un h1, une ligne d'appoint, un côté droit,
 * et devant le titre un éventuel retour. */
export function ScreenHeader({
  title,
  sub,
  aside,
  lead,
}: {
  title: ReactNode;
  sub?: ReactNode;
  aside?: ReactNode;
  lead?: ReactNode;
}) {
  return (
    <div className="screen-head">
      {lead}
      <div className="screen-head-main">
        <h1 className="screen-title">{title}</h1>
        {sub && <div className="screen-sub">{sub}</div>}
      </div>
      {aside && <div className="screen-aside">{aside}</div>}
    </div>
  );
}
